import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';
import { API } from '../App';

const VideosPage = () => {
  const [videos, setVideos] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [videosRes, settingsRes] = await Promise.all([
        axios.get(`${API}/videos`),
        axios.get(`${API}/settings`)
      ]);
      setVideos(videosRes.data);
      setSettings(settingsRes.data);
    } catch (error) {
      console.error('Error fetching videos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '5rem' }}>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-600"></div>
        </div>
      </div>
    );
  }

  if (settings?.videos_show_coming_soon) {
    return (
      <div>
        <Navbar />
        <div className="page-header">
          <div className="container">
            <h1 data-testid="page-title">Video Library</h1>
          </div>
        </div>
        <section className="py-8 container text-center">
          <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚀</div>
            <h2 style={{ marginBottom: '1rem' }}>Coming Soon</h2>
            <p style={{ color: 'var(--muted-foreground)', fontSize: '1.125rem' }}>We're preparing video content for you. Stay tuned!</p>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  const categories = ['all', ...new Set(videos.map(v => v.category))];
  const filteredVideos = selectedCategory === 'all' ? videos : videos.filter(v => v.category === selectedCategory);

  return (
    <div>
      <Navbar />
      
      <div className="page-header">
        <div className="container">
          <h1 data-testid="page-title">Video Library</h1>
          <p>Expert video lectures and strategy sessions</p>
        </div>
      </div>

      <section className="py-8 container">
        <div style={{ marginBottom: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={selectedCategory === cat ? 'btn-primary' : 'btn-secondary'}
              data-testid={`category-${cat}`}
            >
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </button>
          ))}
        </div>

        {filteredVideos.length === 0 ? (
          <div className="card text-center" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <p style={{ color: 'var(--muted-foreground)', fontSize: '1.125rem' }}>No videos available yet.</p>
          </div>
        ) : (
          <div className="grid grid-3">
            {filteredVideos.map((video) => (
              <div key={video.id} className="card" data-testid={`video-${video.id}`}>
                <div style={{ width: '100%', height: '180px', background: 'var(--secondary)', borderRadius: '12px', marginBottom: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3rem' }}>
                  🎥
                </div>
                <h3 style={{ marginBottom: '0.5rem' }}>{video.title}</h3>
                {video.description && (
                  <p style={{ color: 'var(--muted-foreground)', fontSize: '0.875rem', marginBottom: '0.5rem' }}>{video.description}</p>
                )}
                <div style={{ fontSize: '0.875rem', color: 'var(--primary)' }}>
                  {video.category} {video.duration && `• ${Math.floor(video.duration / 60)} min`}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};

export default VideosPage;